// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const shellos: PokeData = {
  "id": 422,
  "name": "shellos",
  "height": 3,
  "weight": 63,
  "base_experience": 65,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "tackle",
    "body-slam",
    "water-gun",
    "hydro-pump",
    "recover",
    "harden",
    "mud-slap",
    "hidden-power",
    "rain-dance",
    "ancient-power",
    "memento",
    "mud-sport",
    "muddy-water",
    "water-pulse",
    "earth-power",
    "mud-bomb"
  ],
  "moves": [
    "tackle",
    "body-slam",
    "hydro-pump",
    "mud-slap",
    "rain-dance",
    "ancient-power",
    "earth-power",
    "mud-bomb",
    "liquidation",
    "bubble",
    "brine",
    "water-spout",
    "life-dew"
  ],
  "evolution_chain": {
    "id": 218,
    "item": null,
    "species": [
      {
        "name": "shellos",
        "order": 450,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "gastrodon",
        "order": 451,
        "types": [
          PokeType.WATER,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 422,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 65.5,
    "speed": 34,
    "ability_power": 57
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
